/* Empreinte modifiee le 2026-09-24 : le CDN avait servi ce fichier en 502
   pendant la propagation du deploiement, et les navigateurs gardaient la
   reponse en echec. Changer le contenu change l'URL versionnee, ce qu'aucun
   cache ne peut servir. Ligne sans effet, supprimable. */
/* ============================================================
   Site Header — JS original (Stratégie 2)
   - En-tête transparent sur la page d'accueil, plein au scroll
   - Drawer mobile accessible
   ============================================================ */
(function () {
  'use strict';

  function initHeader() {
    var header = document.querySelector('[data-lf-header]');
    if (!header) return;

    var isTransparent = header.dataset.transparent === 'true';
    var threshold = parseInt(header.dataset.threshold || '40', 10);
    var isHome = document.body.classList.contains('template-index');
    // Superposition seulement au-dessus d'un visuel plein cadre (voir theme.liquid).
    var overlayHome = isTransparent && isHome && document.body.classList.contains('lf-accueil-visuel');
    var announce = document.querySelector('[data-lf-ann]');
    var main = document.getElementById('MainContent');

    function annHeight() { return announce ? announce.offsetHeight : 0; }

    // Compense le header fixe + barre d'annonce.
    function offset() {
      var h = header.offsetHeight;
      document.body.style.setProperty('--lf-header-h', h + 'px');
      document.body.style.paddingTop = '';
      // Le contenu (#MainContent) passe sous le header fixe, sauf homepage transparente.
      if (main) main.style.paddingTop = overlayHome ? '' : h + 'px';
    }

    /* Le menu tient-il dans sa colonne ? On le mesure sur une ligne, logo
       a sa pleine largeur ; sinon il passe sous le logo. La mesure se
       refait quand la largeur change, jamais au defilement : le logo qui
       retrecit ne doit pas faire sauter l'en-tete d'une ligne a deux. */
    var menuNav = header.querySelector('.lf-hdr__menu');
    var colNav = header.querySelector('.lf-hdr__col--start');
    function placerMenu() {
      if (!menuNav || !colNav || !window.lfPlacerMenu) return;
      header.classList.add('lf-hdr--fige', 'lf-hdr--mesure');
      window.lfPlacerMenu(header, false);
      header.classList.remove('lf-hdr--mesure');
      void header.offsetWidth;
      header.classList.remove('lf-hdr--fige');
    }

    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > threshold);
      // Le header se place sous la barre d'annonce, puis remonte au scroll.
      header.style.top = Math.max(0, annHeight() - y) + 'px';

      if (!overlayHome) {
        header.classList.remove('is-top');
        return;
      }
      if (y <= threshold) {
        header.classList.add('is-top');
      } else {
        header.classList.remove('is-top');
      }
    }

    placerMenu();
    offset();
    update();
    // Les polices changent la largeur des intitules une fois chargees.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { placerMenu(); offset(); });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { placerMenu(); offset(); update(); }, { passive: true });
  }

  /* ---- Sous-menus (deroulant et mega menu) ----
     Ils s'ouvrent au survol et au focus, en CSS. Le script tient
     aria-expanded a jour — il restait a « false » panneau ouvert — et
     ajoute Echap, qui referme le panneau et rend le focus a son intitule :
     un contenu qui apparait au survol ou au focus doit pouvoir se fermer
     sans bouger la souris. */
  function initSousMenus() {
    var items = document.querySelectorAll('[data-lf-header] .lf-hdr__item--has-sub');
    function etat(item) {
      var lien = item.querySelector('.lf-hdr__link');
      var ouvert = !item.classList.contains('is-ferme') &&
        (item.matches(':hover') || item.contains(document.activeElement));
      if (lien) lien.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    }
    items.forEach(function (item) {
      if (item.dataset.lfSousMenu) return;
      item.dataset.lfSousMenu = '1';
      /* Les visuels du mega menu n'ont pas de `src` au rendu : ils ne
         pesent rien au chargement des pages et arrivent a la premiere
         ouverture. */
      function charger() {
        item.querySelectorAll('img[data-lf-src]').forEach(function (img) {
          img.addEventListener('load', function () { img.classList.add('is-charge'); }, { once: true });
          if (img.dataset.lfSrcset) img.srcset = img.dataset.lfSrcset;
          img.src = img.dataset.lfSrc;
          img.removeAttribute('data-lf-src');
          if (img.complete) img.classList.add('is-charge');
        });
      }
      item.addEventListener('mouseenter', function () { charger(); etat(item); });
      item.addEventListener('mouseleave', function () {
        if (!item.contains(document.activeElement)) item.classList.remove('is-ferme');
        etat(item);
      });
      item.addEventListener('focusin', function () { charger(); etat(item); });
      item.addEventListener('focusout', function (e) {
        if (item.contains(e.relatedTarget)) return;
        if (!item.matches(':hover')) item.classList.remove('is-ferme');
        // Le focus n'a pas encore change d'element a cet instant.
        setTimeout(function () { etat(item); }, 0);
      });
    });
    /* Trajectoire vers le mega panneau. La souris qui file vers une carte
       lointaine quitte l'intitule par le cote, bien avant d'atteindre la
       plaque : sans cela le panneau se refermait en route. Tant qu'elle
       reste dans le triangle forme par son point de sortie et le bord haut
       du panneau, il reste ouvert ; elle en sort, s'arrete ou atteint le
       panneau, et le survol ordinaire reprend la main. */
    var enTete = document.querySelector('[data-lf-header]');
    var souris = { x: 0, y: 0 };
    var visee = null;
    function relacher() {
      if (!visee) return;
      clearTimeout(visee.minuterie);
      visee.item.classList.remove('is-maintenu');
      if (enTete) enTete.classList.remove('lf-hdr--visee');
      var item = visee.item;
      visee = null;
      etat(item);
    }
    function dansTriangle(p, a, b, c) {
      function signe(p1, p2, p3) { return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y); }
      var d1 = signe(p, a, b), d2 = signe(p, b, c), d3 = signe(p, c, a);
      return !(((d1 < 0) || (d2 < 0) || (d3 < 0)) && ((d1 > 0) || (d2 > 0) || (d3 > 0)));
    }
    items.forEach(function (item) {
      var panneau = item.querySelector('.lf-hdr__dropdown--mega');
      if (!panneau || item.dataset.lfVisee) return;
      item.dataset.lfVisee = '1';
      item.addEventListener('mouseleave', function (e) {
        if (item.classList.contains('is-ferme')) return;
        var r = panneau.getBoundingClientRect();
        if (r.height === 0 || getComputedStyle(panneau).visibility !== 'visible') return;
        // Seulement en descendant vers la plaque, depuis au-dessus d'elle.
        if (e.clientY >= r.top || e.clientY < souris.y - 1) return;
        relacher();
        visee = {
          item: item,
          a: { x: e.clientX, y: e.clientY - 4 },
          b: { x: r.left - 24, y: r.top + 8 },
          c: { x: r.right + 24, y: r.top + 8 },
          minuterie: setTimeout(relacher, 700)
        };
        item.classList.add('is-maintenu');
        if (enTete) enTete.classList.add('lf-hdr--visee');
      });
      item.addEventListener('mouseenter', function () { if (visee && visee.item === item) relacher(); });
    });
    document.addEventListener('mousemove', function (e) {
      var p = { x: e.clientX, y: e.clientY };
      if (visee && !dansTriangle(p, visee.a, visee.b, visee.c)) relacher();
      else if (visee) {
        // Elle avance : on lui laisse le temps d'arriver.
        clearTimeout(visee.minuterie);
        visee.minuterie = setTimeout(relacher, 450);
      }
      souris = p;
    }, { passive: true });

    if (document.documentElement.dataset.lfSousMenusEchap) return;
    document.documentElement.dataset.lfSousMenusEchap = '1';
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-lf-header] .lf-hdr__item--has-sub').forEach(function (item) {
        if (item.classList.contains('is-ferme')) return;
        if (!item.matches(':hover') && !item.contains(document.activeElement)) return;
        item.classList.add('is-ferme');
        var lien = item.querySelector('.lf-hdr__link');
        if (lien && item.contains(document.activeElement) && document.activeElement !== lien) lien.focus();
        etat(item);
      });
    });
  }

  function initDrawer() {
    var drawer = document.querySelector('[data-lf-drawer]');
    if (!drawer) return;

    var openBtn = document.querySelector('[data-lf-drawer-open]');
    var closers = drawer.querySelectorAll('[data-lf-drawer-close]');
    // Focus garde dans le menu tant qu'il est ouvert : voir lf-calque.js.
    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (window.lfCalque) window.lfCalque.ouvrir(drawer, { retour: openBtn });
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (window.lfCalque) window.lfCalque.fermer(drawer);
    }

    if (openBtn) openBtn.addEventListener('click', open);
    closers.forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function boot() {
    initHeader();
    initSousMenus();
    initDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
